import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { UserContext } from "context";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import Icon from "@mui/material/Icon";
import { gapi } from "gapi-script"; // Import gapi

const LogoutButton = ({ textColor }) => {
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const handleLogout = () => {
    const isGoogleUser = localStorage.getItem("isGoogleUser") === "true";

    if (isGoogleUser) {
      const auth2 = gapi.auth2.getAuthInstance();
      if (auth2) {
        auth2
          .signOut()
          .then(() => {
            localStorage.removeItem("token");
            localStorage.removeItem("isGoogleUser");
            setUser(null);
            navigate("/login"); // Redirect to login page
          })
          .catch((error) => {
            console.error("Google logout error:", error);
            setLogoutDialogOpen(false);
            localLogout();
          });
      } else {
        console.error("gapi.auth2 is not initialized");
        setLogoutDialogOpen(false);
        localLogout();
      }
    } else {
      setLogoutDialogOpen(false);
      localLogout();
    }
  };

  const localLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("isGoogleUser");
    setUser(null);
    navigate("/login"); // Redirect to login page
  };

  return (
    <>
      <MDButton
        variant="outlined"
        color={textColor}
        onClick={() => setLogoutDialogOpen(true)}
        sx={{ mt: 2, color: textColor }}
      >
        <Icon fontSize="small">logout</Icon>
        <MDTypography
          color={textColor}
          ml={0.5}
          component="h6"
          variant="button"
          fontWeight="medium"
        >
          Logout
        </MDTypography>
      </MDButton>
      <Dialog open={logoutDialogOpen} onClose={() => setLogoutDialogOpen(false)}>
        <DialogTitle>Sei sicuro di voler uscire da PermessiOk?</DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions>
          <MDButton onClick={() => setLogoutDialogOpen(false)} color="error">
            Annulla
          </MDButton>
          <MDButton onClick={() => handleLogout()} color="primary">
            Conferma
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

LogoutButton.propTypes = {
  textColor: PropTypes.string,
};

LogoutButton.defaultProps = {
  textColor: "inherit",
};

export default LogoutButton;
